/*
 * Catálogo moderno — Mucho Divertido (assets/catalog-modern.js)
 * -------------------------------------------------------------
 * Compañero de assets/catalog-modern.css. Se carga en colecciones, páginas tipo "page"
 * y producto; solo actúa si la página muestra (o va a cargar) tarjetas de producto,
 * así que las páginas con submenús de colecciones quedan fuera.
 *
 * Qué hace:
 * 1. Marca las tarjetas de producto, los "valores de marca", las reseñas y la
 *    cabecera/pie de las listas de producto con .mdv-reveal y las muestra (.is-in)
 *    cuando entran en pantalla, escalonando las que aparecen a la vez.
 * 2. Vigila la rejilla: las tarjetas que llegan después (scroll infinito, filtros,
 *    orden) también se preparan. Las que ya están a la vista al llegar se muestran
 *    sin animar para no duplicar la transición propia del tema.
 *
 * Sin JavaScript, con "reducir movimiento" o dentro del editor de temas no se oculta nada.
 * En Dwell el scroll de escritorio lo hace .page-wrapper, no la ventana, así que el
 * listener de seguridad va en captura sobre el documento.
 */
(function () {
  var d = document;
  var html = d.documentElement;
  var main = d.querySelector('main.mdv-catalog');
  if (!main) return;
  if (!main.querySelector('product-card, product-recommendations')) return; /* página sin productos (p. ej. submenús): nada que hacer */
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('classList' in html)) return;

  var SEL = 'product-card, .valores__item, .jdgm-widget, .section-resource-list__header .group-block, .section-resource-list__content > *';
  var STAGGER_CAP = 7;
  var STAGGER_MS = 70;

  html.classList.add('mdv-catalog-js');

  function viewportHeight() {
    return window.innerHeight || html.clientHeight;
  }
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < viewportHeight() * 0.96 && r.bottom > 0;
  }
  /* Ya quedó por encima de la pantalla (el usuario lo saltó con un gesto rápido). */
  function passed(el) {
    return el.getBoundingClientRect().bottom < 0;
  }

  /* Quita el retardo escalonado una vez terminada la entrada, para que el hover responda al instante. */
  function clearDelay(el) {
    el.style.transitionDelay = '';
  }

  /* Muestra un grupo de elementos escalonando los que aparecen a la vez (orden visual).
     El escalonado va como transition-delay en línea (no depende de temporizadores) y se
     limpia al acabar la transición. */
  function reveal(list, animate) {
    if (!list.length) return;
    if (!animate) {
      for (var n = 0; n < list.length; n++) list[n].classList.add('is-in');
      return;
    }
    list.sort(function (a, b) {
      var ra = a.getBoundingClientRect();
      var rb = b.getBoundingClientRect();
      return ra.top - rb.top || ra.left - rb.left;
    });
    void main.offsetWidth; /* fija el estado inicial para que la transición se ejecute */
    list.forEach(function (el, i) {
      var delay = Math.min(i, STAGGER_CAP) * STAGGER_MS;
      if (delay) {
        el.style.transitionDelay = delay + 'ms';
        var done = function (ev) {
          if (ev && ev.target !== el) return;
          el.removeEventListener('transitionend', done);
          clearDelay(el);
        };
        el.addEventListener('transitionend', done);
        setTimeout(done, delay + 900); /* por si la transición no llega a dispararse */
      }
      el.classList.add('is-in');
    });
  }

  var pending = []; /* elementos a la espera de entrar en pantalla (también con IntersectionObserver, como respaldo) */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        var batch = [];
        for (var e = 0; e < entries.length; e++) {
          if (!entries[e].isIntersecting) continue;
          io.unobserve(entries[e].target);
          if (entries[e].target.classList.contains('is-in')) continue;
          batch.push(entries[e].target);
        }
        reveal(batch, true);
      },
      { threshold: 0, rootMargin: '0px 0px -6% 0px' } /* cualquier píxel visible cuenta */
    );
  }

  /* Prepara los elementos nuevos. `animateVisible` decide si los que ya están a la vista entran animados. */
  function enhance(animateVisible) {
    var found = main.querySelectorAll(SEL);
    var fresh = [];
    for (var f = 0; f < found.length; f++) {
      var el = found[f];
      if (el.classList.contains('mdv-reveal')) continue;
      if (el.closest('.facets, .facets-block-wrapper, theme-drawer, dialog')) continue; /* filtros y diálogos: nunca */
      var parentMatch = el.parentElement && el.parentElement.closest(SEL);
      if (parentMatch && main.contains(parentMatch)) continue; /* solo el nivel superior, sin anidar animaciones */
      fresh.push(el);
    }
    if (!fresh.length) return;

    var now = [];
    for (var i = 0; i < fresh.length; i++) {
      fresh[i].classList.add('mdv-reveal');
      if (inView(fresh[i])) {
        now.push(fresh[i]);
      } else {
        pending.push(fresh[i]);
        if (io) io.observe(fresh[i]);
      }
    }
    reveal(now, animateVisible);
  }

  /* Lo que ya está en pantalla al cargar: si vamos a tiempo (antes del primer pintado) entra
     animado; si el script llega tarde, se muestra directamente para no parpadear. */
  var early = !(window.performance && performance.now && performance.now() > 1500);
  enhance(early);

  /* Tarjetas que llegan después (scroll infinito, filtros, orden): las visibles se muestran
     directamente (el tema ya las anima), las que quedan más abajo entran al hacer scroll. */
  if ('MutationObserver' in window) {
    var scheduled = false;
    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        if (mutations[m].addedNodes.length) {
          if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(function () {
              scheduled = false;
              enhance(false);
            });
          }
          return;
        }
      }
    });
    mo.observe(main, { childList: true, subtree: true });
  }

  /* Red de seguridad por posición: navegadores sin IntersectionObserver y casos límite. */
  function check() {
    var rest = [];
    var batch = [];
    for (var c = 0; c < pending.length; c++) {
      var el = pending[c];
      if (el.classList.contains('is-in')) continue;
      if (passed(el)) {
        el.classList.add('is-in'); /* pasado de largo con un scroll rápido: se muestra sin animar */
        if (io) io.unobserve(el);
        continue;
      }
      if (inView(el)) batch.push(el);
      else rest.push(el);
    }
    pending = rest;
    reveal(batch, true);
  }
  d.addEventListener('scroll', check, { capture: true, passive: true });
  window.addEventListener('load', check);
  window.addEventListener('resize', check);
  setTimeout(check, 400);

  /* Último recurso: si algo quedase oculto tras un tiempo (p. ej. dentro de un contenedor
     que no notifica intersección), se muestra igualmente. */
  setTimeout(function () {
    var hidden = main.querySelectorAll('.mdv-reveal:not(.is-in)');
    for (var h = 0; h < hidden.length; h++) {
      if (inView(hidden[h]) || passed(hidden[h])) hidden[h].classList.add('is-in');
    }
  }, 2500);
})();
